import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import { sortedDropdownItemLabels } from '../utils/utils';

import DA from '../store/ReduxAccess';

import BusinessTypeWidget from './BusinessTypeWidget';
import CrmTextField from './CrmTextField';
import WebLinkEditor from './WebLinkEditor';
import StateSelector from './StateSelector';
import PhoneInput from './PhoneInput';
import KSelect from './KSelect';

const localStyles = (theme) => ({
  root: {
    marginTop: '12px',
  },
  firmContactCard: {
    marginTop: '32px',
    padding: '0 12px 10px 12px',
    minWidth: '440px',
  },
});

/*
 *Call with something like:
  <NewOrgWithContactPanel
    ownerModal={this}
    firmType={this.props.firmType}
    onFirmTypeChange={(newFirmType) => {this.setState({ firmType: newFirmType })}}
  />
 */

function computeOrgTypeLabel(firmType) {
  if (firmType == 'Educational Consultant') {
    return 'Consultancy';
  } else {
    if (firmType) {
      return firmType;
    } else {
      return 'Organization';
    }
  }
}

class NewOrgWithContactPanel extends React.Component {
  render() {
    const { classes, ownerModal, firmType, onFirmTypeChange } = this.props;

    const possibleOwners = DA.getAllFirmUsers();
    const possibleCompanyTemperatures = sortedDropdownItemLabels('Referral Company Temperature');
    const possibleContactTemperatures = sortedDropdownItemLabels('Referral Contact Temperature');
    const orgTypeLabel = computeOrgTypeLabel(firmType);

    return (
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BusinessTypeWidget
                  visibleFirmId={0}
                  filterOutPrivatePractitioners={true}
                  firmType={firmType}
                  onChange={(newFirmType) => onFirmTypeChange(newFirmType)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label={orgTypeLabel + ' Name'}
                  id="companyName"
                  required
                  fullWidth
                  value={ownerModal.state.companyName}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <WebLinkEditor
                  label="Website"
                  linkBoxWidth="85%"
                  initialValue={ownerModal.state.webUrl}
                  clickawayShouleSave={false}
                  onDelete={() => {}}
                  onNewValue={(newText) => ownerModal.setState({ webUrl: newText })}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label={orgTypeLabel + ' Description'}
                  id="companyDescription"
                  fullWidth
                  value={ownerModal.state.companyDescription}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="Address"
                  id="addressLine1"
                  fullWidth
                  value={ownerModal.state.addressLine1}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="Address Line 2"
                  id="addressLine2"
                  fullWidth
                  value={ownerModal.state.addressLine2}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="City"
                  id="city"
                  fullWidth
                  value={ownerModal.state.city}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={8} style={{ marginTop: '8px' }}>
                <StateSelector
                  value={ownerModal.state.state}
                  onChange={(newVal) => ownerModal.setState({ state: newVal })}
                />
              </Grid>
              <Grid item xs={4}>
                <CrmTextField
                  label="Zip Code"
                  fullWidth
                  value={ownerModal.state.zip}
                  onChange={(event) => ownerModal.setState({ zip: event.target.value.trim() })}
                />
              </Grid>
              <Grid item xs={12}>
                <KSelect
                  label={orgTypeLabel + ' Temperature'}
                  fullWidth={true}
                  liveOptions={possibleCompanyTemperatures}
                  liveValues={possibleCompanyTemperatures}
                  value={ownerModal.state.companyTemperature}
                  onChange={(event) => ownerModal.setState({ companyTemperature: event.target.value })}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <h4>Contact</h4>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <CrmTextField
                  label="Contact Name"
                  id="contactName"
                  fullWidth
                  value={ownerModal.state.contactName}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="Job Title"
                  id="contactJobTitle"
                  fullWidth
                  value={ownerModal.state.contactJobTitle}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="Contact Description"
                  id="contactDescription"
                  fullWidth
                  value={ownerModal.state.contactDescription}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={6}>
                <PhoneInput
                  label="Phone 1"
                  possibleRoles={ownerModal.possibleContactPhoneRoles}
                  actualRoles={ownerModal.state.contactPhone1Roles}
                  number={ownerModal.state.contactPhone1Number}
                  onRolesChange={(rolesObj) => ownerModal.handleContactPhone1RolesChange(rolesObj)}
                  onNumberChange={(newNumber) => ownerModal.handleContactPhone1NumberChange(newNumber)}
                />
              </Grid>
              <Grid item xs={6}>
                <PhoneInput
                  label="Phone 2"
                  possibleRoles={ownerModal.possibleContactPhoneRoles}
                  actualRoles={ownerModal.state.contactPhone2Roles}
                  number={ownerModal.state.contactPhone2Number}
                  onRolesChange={(rolesObj) => ownerModal.handleContactPhone2RolesChange(rolesObj)}
                  onNumberChange={(newNumber) => ownerModal.handleContactPhone2NumberChange(newNumber)}
                />
              </Grid>
              <Grid item xs={12}>
                <CrmTextField
                  label="Contact Email"
                  id="contactEmail"
                  fullWidth
                  value={ownerModal.state.contactEmail}
                  onChange={(event) => ownerModal.handleTextChange(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <KSelect
                  label="Owner"
                  fullWidth={true}
                  liveOptions={possibleOwners.map((c) => c.name)}
                  liveValues={possibleOwners.map((c) => c.personId)}
                  value={ownerModal.state.contactOwnerId}
                  onChange={(event) => ownerModal.setState({ contactOwnerId: event.target.value })}
                />
              </Grid>
              <Grid item xs={12}>
                <KSelect
                  label="Contact Temperature"
                  fullWidth={true}
                  liveOptions={possibleContactTemperatures}
                  liveValues={possibleContactTemperatures}
                  value={ownerModal.state.contactTemperature}
                  onChange={(event) => ownerModal.setState({ contactTemperature: event.target.value })}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(localStyles)(NewOrgWithContactPanel);
